module.exports = function (savedCardService) {
    return {
        restrict: 'E',
        scope: {
            orderId: '@'
        },
        link(scope) {
            scope.cardSaved = false;

            scope.saveCard = function () {
                scope.cardSaved = true;

                savedCardService.saveCardForOrder(scope.orderId)
                    .then(function () {
                        delete scope.error;
                    })
                    .catch(function () {
                        scope.cardSaved = false;
                        scope.error = 'There was an error saving your card.';
                    });
            };
        },
        template: require('./save-card-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/savedcard/save-card-directive.js
 **/